"use client"

import { usePathname, useRouter } from "next/navigation"
import { List as TOC } from "lucide-react"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import TableOfContents from "@/components/navigation/TableOfContents"
import { useEffect, useState } from "react"

export function ResponsiveTOC() {
  const pathname = usePathname()
  const router = useRouter()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      const url = new URL(window.location.href)
      url.hash = ""
      router.replace(url.toString(), { scroll: false })
    }
  }, [isOpen, router])

  const handleToggle = (value: string) => {
    setIsOpen(value === "toc")
  }

  return (
    <div className="lg:hidden mt-4">
      <Accordion type="single" collapsible onValueChange={handleToggle}>
        <AccordionItem value="toc">
          <AccordionTrigger>
            <div className="flex justify-start items-center">
              <TOC className="mr-2 h-4 w-4" />
              目次
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <TableOfContents
              key={pathname}
              contentId="content"
              containerId="content-view"
              targetSelectors="h2, h3, h4"
              ignoreIds={[]}
              tocContainer=".toc-container"
            />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  )
}
